import React from 'react';
import { Shield, CheckCircle } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function GuaranteeSection() {
  return <section className="py-20 md:py-28 px-6 bg-base" data-id="element-338">
      <div className="max-w-2xl mx-auto" data-id="element-339">
        {/* Section label */}
        <FadeIn data-id="element-340">
          <div className="flex items-center gap-4 mb-16" data-id="element-341">
            <div className="h-px bg-border-accent flex-grow" data-id="element-342" />
            <span className="font-ui text-xs font-semibold tracking-widest uppercase text-accent-primary" data-id="element-343">
              ◆ The Guarantee ◆
            </span>
            <div className="h-px bg-border-accent flex-grow" data-id="element-344" />
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-345">
          <div className="bg-elevated border-2 border-success rounded-sm p-10 md:p-14 text-center relative overflow-hidden" data-id="element-346">
            {/* Subtle green glow */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-40 bg-success/5 blur-3xl pointer-events-none" data-id="element-347" />

            <div className="relative z-10" data-id="element-348">
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-success/10 border border-success/20 mb-8" data-id="element-349">
                <Shield className="w-10 h-10 text-success" data-id="element-350" />
              </div>

              <h2 className="font-display text-3xl md:text-4xl font-bold text-text-primary mb-4" data-id="element-351">
                7-Day Money-Back Guarantee
              </h2>

              <p className="font-ui text-xs font-semibold tracking-widest uppercase text-success mb-8" data-id="element-352">
                Zero Risk. Full Protection.
              </p>

              <p className="font-body text-xl text-text-secondary leading-relaxed mb-10 max-w-lg mx-auto" data-id="element-353">
                If within 7 days you don't feel this book was worth your time —
                we'll refund your money. No questions asked. No forms. No
                hassle.
              </p>

              {/* Trust signals */}
              <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 mb-10 font-ui text-sm text-text-muted" data-id="element-354">
                <span className="flex items-center gap-2" data-id="element-355">
                  <CheckCircle className="w-4 h-4 text-success" data-id="element-356" />
                  Instant refund process
                </span>
                <span className="flex items-center gap-2" data-id="element-357">
                  <CheckCircle className="w-4 h-4 text-success" data-id="element-358" />
                  No questions asked
                </span>
                <span className="flex items-center gap-2" data-id="element-359">
                  <CheckCircle className="w-4 h-4 text-success" data-id="element-360" />
                  Keep your download
                </span>
              </div>

              <p className="font-display text-lg italic text-text-secondary mb-8" data-id="element-361">
                We believe in what we publish. And we believe you will too.
              </p>

              <Button href="#offer" className="w-full md:w-auto text-sm md:text-base" data-id="element-362">
                Try It Risk-Free &rarr;
              </Button>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}